import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=83a81b5a&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&id=83a81b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a81b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/newleaf.leox.dev/newleaf.leox.dev/modules/ACNLPatternTool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83a81b5a')) {
      api.createRecord('83a81b5a', component.options)
    } else {
      api.reload('83a81b5a', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=83a81b5a&scoped=true&", function () {
      api.rerender('83a81b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/positioned/Banner.vue"
export default component.exports